/**
 * @file automatically generated from MApp.Endpoints.TileOrderController
 */ 

import { MetadataClient } from '../metadataClient';
import { ISaveTileOrder, ITileOrder, ITileJobListItem, ISaveTileJob, ITileJob, IValidationResult } from '../models';

export class TileOrderClient extends MetadataClient {

    public static getAppCache(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/tiles/create/appcache/${encodeURIComponent(id)}`)
        );
    }

    public static getMapViewCache(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/tiles/create/mapviewcache/${encodeURIComponent(id)}`)
        );
    }

    public static getWmtsVectorCache(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/tiles/create/wmtsvectorcache/${encodeURIComponent(id)}`)
        );
    }

    public static clearWmtsCache(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/tiles/create/wmtscache/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getWmtsCache(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/tiles/create/wmtscache/${encodeURIComponent(id)}`)
        );
    }

    public static getVectorSetCache(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/tiles/create/vectorsetcache/${encodeURIComponent(id)}`)
        );
    }

    public static saveTileOrder(tileOrder: ISaveTileOrder) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/tileorders`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(tileOrder)
			})
        );
    }

    public static cancelTileOrder(id: string) {
        return MetadataClient.ajax<ITileOrder>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/tileorders/cancel/${encodeURIComponent(id)}`)
        );
    }

    public static getTileOrder(id: string) {
        return MetadataClient.ajax<ITileOrder>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/tileorders/${encodeURIComponent(id)}`)
        );
    }

    public static deleteTileOrder(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/tileorders/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getTileOrders() {
        return MetadataClient.ajax<ITileOrder[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/tileorders`)
        );
    }

    public static getTileJobs() {
        return MetadataClient.ajax<ITileJobListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/tilejobs`)
        );
    }

    public static deleteTileJob(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/tilejobs?id=${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static saveTileJob(tileJob: ISaveTileJob) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/tilejobs`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(tileJob)
			})
        );
    }

    public static updateTileJob(id: string, tileJob: ISaveTileJob) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/tilejobs/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(tileJob)
			})
        );
    }

    public static getTileJob(id: string) {
        return MetadataClient.ajax<ITileJob>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/tilejobs/${encodeURIComponent(id)}`)
        );
    }

    public static isValidTileJob(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/tilejobs/isvalid?name=${encodeURIComponent(name)}`)
        );
    }

    public static createByBounds(datasets: string, xMin: number, yMin: number, xMax: number, yMax: number, srid: number) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/tiles/create/${xMin},${yMin},${xMax},${yMax}?datasets=${encodeURIComponent(datasets)}&srid=${srid}`),
			true
        );
    }
}
